import axios from "./axios"

const url = "/projects"

const fetchErrorMsg = "Error fetching projects:"
const createErrorMsg = "Error creating project:"
const editErrorMsg = "Error updating project:"
const destroyErrorMsg = "Error deleting project:"

const ProjectApi = () => {
	const getAll = async () => {
		try {
			const response = await axios.get(url)
			return response.data
		} catch (error) {
			console.error(fetchErrorMsg, error)
			throw error
		}
	}

	const create = async (project) => {
		try {
			const response = await axios.post(url, project)

			return response.data
		} catch (error) {
			console.error(createErrorMsg, error)
			throw error
		}
	}

	const edit = async (id, project) => {
		try {
			const response = await axios.put(`${url}/${id}`, project)

			return response.data
		} catch (error) {
			console.error(editErrorMsg, error)
			throw error
		}
	}

	const destroy = async (id) => {
		try {
			const response = await axios.delete(`${url}/${id}`)

			return response.data
		} catch (error) {
			console.error(destroyErrorMsg, error)
			throw error
		}
	}

	return {
		getAll,
		create,
		edit,
		destroy,
	}
}

export default ProjectApi
